export default "__VITE_ASSET__pzM0bZUr__"